import React from 'react'
import { connect } from 'react-redux'
import CouponActions from '../../Redux/CouponRedux'
import ProductActions from '../../Redux/ProductRedux'
import InsuranceActions from '../../Redux/InsuranceRedux'
import InventoryActions from '../../Redux/InventoryRedux'
import IndividualModem from './IndividualModem'
import IndividualAttraction from './IndividualAttraction'
import IndividualInsurance from './IndividualInsurance'
import IndividualEcommerce from './IndividualEcommerce'
import RenderTable from './RenderTable'

class IndividualCoupon extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: null,
      tab: 'modem',
      selectedModem: '',
      selectedDestination: '',
      selectedAttraction: '',
      form: {
        discountable_id: '',
        discountable_type: ''
      }
    }
  }

  componentDidMount = () => {
    this._fetchSelectors()
  }

  _fetchSelectors = () => {
    this.props.getProductCustom()
    this.props.getTravelPackage()
    this.props.getInventoryCustom()
  }

  _fetchCouponItem = () => {
    this.props.getCouponItemRequest({ uuid: this.props.uuid })
  }

  _toggleTab = (tab) => {
    this.setState({ tab })
  }

  _renderInterface = (PRODUCT_TYPE) => {
    switch (PRODUCT_TYPE) {
      case 'modem':
        return <IndividualModem fetchCouponItem={this._fetchCouponItem} tag={this.props.tag} uuid={this.props.uuid} source_type={this.props.source_type} />
      case 'attraction':
        return <IndividualAttraction fetchCouponItem={this._fetchCouponItem} tag={this.props.tag} uuid={this.props.uuid} source_type={this.props.source_type} />
      case 'insurance':
        return <IndividualInsurance fetchCouponItem={this._fetchCouponItem} tag={this.props.tag} uuid={this.props.uuid} source_type={this.props.source_type} />
      case 'inventory':
        return <IndividualEcommerce fetchCouponItem={this._fetchCouponItem} tag={this.props.tag} uuid={this.props.uuid} source_type={this.props.source_type} />
      case 'all':
        return (
          <div>
            { this._selectTab() }
            { this._renderInterface(this.state.tab) }
          </div>
        )
      default:
        return null
    }
  }

  _selectTab = () => {
    return (
      <div className='btn-group ml-auto mb-4' role='group'>
        <button onClick={() => this._toggleTab('modem')} className={`btn btn-primary ${this.state.tab === 'modem' ? 'active' : ''}`}>Modem</button>
        <button onClick={() => this._toggleTab('attraction')} className={`btn btn-primary ${this.state.tab === 'attraction' ? 'active' : ''}`}>Attraction</button>
        <button onClick={() => this._toggleTab('insurance')} className={`btn btn-primary ${this.state.tab === 'insurance' ? 'active' : ''}`}>Insurance</button>
        <button onClick={() => this._toggleTab('inventory')} className={`btn btn-primary ${this.state.tab === 'inventory' ? 'active' : ''}`}>Ecommerce</button>
      </div>
    )
  }

  render () {
    const { coupon } = this.props
    return (
      <section className='section' style={{ width: '75vw', height: '90vh' }}>
        <div className='title-block'>
          <h3 className='title mr-auto'>
            Apply Individual Coupon for {this.props.title}
            {
              (coupon.fetching || coupon.processing) &&
              <div className='badge badge-info ml-2'>
                { coupon.fetching ? 'Loading ...' : 'Processing ...' }
              </div>
            }
          </h3>
        </div>
        <div>
          { this._renderInterface(this.props.product_type) }
          <RenderTable closeModal={() => this.props.closeModal()} fetchCouponItem={this._fetchCouponItem} />
          <div className='row'>
            <div className='col-12 text-right'>
              <button onClick={() => this.props.closeModal()} className='btn btn-secondary mr-2'>Close</button>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  coupon: state.coupon
})

const dispatchToProps = (dispatch) => ({
  getProductCustom: () => dispatch(ProductActions.getProductCustomRequest()),
  getTravelPackage: (data) => dispatch(InsuranceActions.getTravelPackageRequest(data)),
  getInventoryCustom: () => dispatch(InventoryActions.getInventoryCustomRequest()),
  getCouponItemRequest: (data) => dispatch(CouponActions.getCouponItemRequest(data))
})

export default connect(stateToProps, dispatchToProps)(IndividualCoupon)



// WEBPACK FOOTER //
// ./src/Containers/Coupon/IndividualCoupon.js